import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { DropdownList, DropdownItem } from 'next-common-lib';
import i18n from 'i18n';
import { isIE } from 'utils/common';
import { getLanguage } from 'utils/cookies';
import * as termsActions from 'redux/ducks/Terms/TermsDucks';

export const DropDownCountry = ({ isFullWidth }) => {
  const dispatch = useDispatch();
  const { setValue } = useFormContext();
  const [nationName, setNationName] = useState(i18n.t('MB_T_NATIONCODE_KOREA'));
  const { nationList, residenceCntry } = useSelector(state => state.terms);
  const langCd = getLanguage();
  useEffect(() => {
    dispatch(termsActions.getNationList(langCd));
    setValue('zoneCd', residenceCntry.zoneCd ? residenceCntry.zoneCd : 'KR');
    setNationName(i18n.t('MB_T_NATIONCODE_KOREA'));
  }, []);

  return (
    <>
      {isIE() ? (
        <select
          className="ie-dropdown"
          onChange={e => {
            const payload = { value: e.target.value };
            dispatch(termsActions.setResidenceCntry(payload));
            setNationName(e.name);
          }}
        >
          {nationList?.map((item, index) => {
            return (
              <option value={item.cntryCd} key={item.cntryCd}>
                {langCd === 'ko' ? `${i18n.t(item.cntryNm)}` : `${i18n.t(item.enCntryNm)}`}
              </option>
            );
          })}
        </select>
      ) : (
        <DropdownList
          componentType="searchbox"
          label={nationName}
          breakNum={5}
          fullWidth={isFullWidth}
          value={residenceCntry.value}
        >
          {nationList?.map((item, index) => {
            return (
              <DropdownItem
                key={item.cntryCd}
                value={item.cntryCd}
                name={langCd === 'ko' ? `${i18n.t(item.cntryNm)}` : `${i18n.t(item.enCntryNm)}`}
                onClick={e => {
                  dispatch(termsActions.setResidenceCntry({ ...e, zoneCd: item.zoneCd }));
                  setValue('zoneCd', item.zoneCd);
                  setNationName(e.name);
                }}
              />
            );
          })}
        </DropdownList>
      )}
    </>
  );
};
DropDownCountry.propTypes = { isFullWidth: PropTypes.bool };
DropDownCountry.defaultProps = { isFullWidth: false };
export default DropDownCountry;
